module.exports = __webpack_public_path__ + "0639c488e0f709c90f5c4088e76f27db.pdf";